export const LinkStyle = {
  outline: 0,
  textDecoration: "none"
};



// WEBPACK FOOTER //
// ./src/utils/styles.ts